import sensors from 'sa-sdk-javascript'
let isProduction = false
if (
  [
    'https://cem-in.myoas.com',
    'https://cem-sin.oppoit.com',
    'https://cem.myoas.com',
    //添加C端域名
    'https://cem-survey.myoas.com',
    'https://cem-survey-sin.oppoit.com',
    'https://cem-survey-in.oppoit.com'

  ].includes(window.location.origin)
) {
  isProduction = true
}
sensors.init({
  server_url: isProduction
    ? 'https://dmg-dts-api.myoas.com/sa?project=CRM_G_UMP'
    : 'https://dmg-dts-api-test.myoas.com/sa?project=CRM_G_UMP',
  is_track_single_page: true, // 单页面配置，默认开启，若页面中有锚点设计，需要将该配置删除，否则触发锚点会多触发 $pageview 事件
  use_client_time: true,
  send_type: 'beacon',
  // 非生产环境开启控制台日志
  show_log: !import.meta.env.PROD,
  heatmap: {
    //是否开启点击图，default 表示开启，自动采集 $WebClick 事件，可以设置 'not_collect' 表示关闭。
    clickmap: 'default',
    //是否开启触达图，not_collect 表示关闭，不会自动采集 $WebStay 事件，可以设置 'default' 表示开启。
    scroll_notice_map: 'default'
  }
})
sensors.registerPage({
  ProjectName: 'UMP_CEM', //DRP_MI（营销互动）,DRP_RP（零售+）,DRP_OM（O2O商城）,DRP_RO（零售运营）,DRP_IS（智慧门店）,UMP_CEM(CEM体验管理平台)
  ModuleName: 'CEM体验管理平台', //模块名称
  platform_type: 'WEB', //H5|WEB
  l3_system_code: 'CRM_G_UMP_CEM'
})
sensors.quick('autoTrack') //用于采集 $pageview 事件
sensors.use('PageLeave', {}) //页面浏览时长
export default sensors
